import { AxiosResponse } from 'axios'
import { Agency } from 'src/types/agency'

import axios from '../../axios'

export const fetchAgencies = async (): Promise<AxiosResponse> => {
  const response = await axios
    .get<{ data: Agency[] }>('/api/agencies')
    .catch((error) => {
      return error.response
    })

  return response
}
